module.exports = __webpack_public_path__ + "img/ercode.9d735555.jpg";